import React from 'react';
import { AdminProvider } from 'models';
import { ignoreExperience, verifyExperience } from 'api/AdminEmploymentHistoryApi';
import { consoleLogInDev } from 'shared';
import { Grid } from '@material-ui/core';
import { PrimaryButton, SecondaryButton } from 'library';

export default function Verify({
    provider,
    refreshProvider,
}: {
    provider: AdminProvider;
    refreshProvider: () => void;
}) {
    const needToVerify =
        provider.licensed_center_employment_history?.ignored_at == null &&
        provider.success_progress[0].provider_completed_background_check_florida == null &&
        provider.licensed_center_employment_history?.listed_has_not_worked_in_center == false;

    const handleVerify = () => {
        verifyExperience(provider)
            .then((result) => {
                alert(`BSP saved: ${JSON.stringify(result)}`);
                refreshProvider();
            })
            .catch(consoleLogInDev);
    };

    const handleIgnore = () => {
        ignoreExperience(provider.licensed_center_employment_history?.id)
            .then(() => {
                alert(`Licensed center employment ignored`);
                refreshProvider();
            })
            .catch(consoleLogInDev);
    };

    return (
        <>
            {needToVerify ? (
                <Grid container item direction="row" alignItems="center" style={{ gap: 20 }} xs={5}>
                    <PrimaryButton
                        onClick={handleVerify}
                        buttonStyle={{ maxWidth: 150, maxHeight: 50 }}
                    >
                        Verify
                    </PrimaryButton>
                    <SecondaryButton
                        onClick={handleIgnore}
                        buttonStyle={{ maxWidth: 150, maxHeight: 50 }}
                    >
                        Ignore
                    </SecondaryButton>
                </Grid>
            ) : null}
        </>
    );
}
